import { useState, useEffect, useRef } from "react";
import { Button } from "@teamscheme/button";
import StaticRoutes from "../static-pages/StaticRoutes";
import { TopFaq } from "../about/FaqPage";
import styled from "styled-components";

const FaqWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export function FaqSection() {
  const faqBodyRef = useRef<HTMLDivElement | null>(null);
  const [faqBodyWidth, setFaqBodyWidth] = useState<number | null>(null);
  useEffect(() => {
    const body = faqBodyRef.current;
    const { setTimeout } = window;
    if (body) {
      const timeout = setTimeout(() => {
        setFaqBodyWidth(body.getBoundingClientRect().width);
      });
      return () => clearTimeout(timeout);
    }
  }, []);
  useEffect(() => {
    const body = faqBodyRef.current;
    if (!body) return;
    let timeout: number | null;
    const onResize = () => {
      setFaqBodyWidth(null);
      if (timeout) clearTimeout(timeout);
      timeout = window.setTimeout(
        () => setFaqBodyWidth(body.getBoundingClientRect().width),
        50
      );
    };
    window.addEventListener("resize", onResize);
    return () => {
      if (timeout) clearTimeout(timeout);
      window.removeEventListener("resize", onResize);
    };
  }, []);
  return (
    <FaqWrapper>
      <div ref={faqBodyRef} style={{ width: faqBodyWidth || undefined }}>
        <h2>Lurer du på noe?</h2>
        <p>
          Finn svar på det du lurer på &ndash; eller ta kontakt med oss på
          chatten. Vi hjelper så gjerne!
        </p>
        <TopFaq />
        <Button linkTo={StaticRoutes.faq.path} variant="outline">
          Se vanlige spørsmål
        </Button>
      </div>
    </FaqWrapper>
  );
}
